// Generated by Melange

import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__KassaSubheader from "../../../molecules/OrgDashboardHeader/KassaSubheader.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../../molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__ReceiptHeader from "./ReceiptHeader.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__ShiftHeader from "./ShiftHeader.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmJournalHeader(Props) {
  let org = Props.org;
  let id = Props.id;
  let openMenu = Props.openMenu;
  let objectId = Props.objectId;
  let setObjectId = Props.setObjectId;
  let objectType = Props.objectType;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const func = Buhta_cabinet__Kassa.KkmManagerService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$1[1];
  const kkmObj = match$1[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Kassa */ 2,
      _0: {
        TAG: /* Kkms */ 0,
        _0: /* List */ 1
      }
    }),
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/back-arrow.svg")
    })
  });
  const subheader = typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? null : JsxRuntime.jsx(Buhta_cabinet__KassaSubheader.make, {
      currentRoute: currentRoute,
      kkm: kkmObj.VAL,
      contextRoute: contextRoute
    });
  const closeReceiptButton = JsxRuntime.jsx("button", {
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/close-20.svg")
    }),
    onClick: (function (param) {
      Curry._1(setObjectId, (function (param) {
        
      }));
    })
  });
  let isShiftOpen;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    isShiftOpen = false;
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$2 = currentRoute._1;
        if (/* tag */ typeof match$2 === "number" || typeof match$2 === "string" || match$2.TAG !== /* Kassa */ 2) {
          isShiftOpen = false;
        } else {
          const match$3 = match$2._0._0;
          if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string") {
            isShiftOpen = false;
          } else {
            const match$4 = match$3._1;
            if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string" || match$4.TAG !== /* Journal */ 2) {
              isShiftOpen = false;
            } else {
              const match$5 = match$4._0;
              if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string") {
                isShiftOpen = false;
              } else {
                let tmp = match$5._0;
                isShiftOpen = /* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* View */ 0 ? false : true;
              }
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$6 = currentRoute._0;
        if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string" || match$6.TAG !== /* Orgs */ 1) {
          isShiftOpen = false;
        } else {
          const match$7 = match$6._0;
          if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string") {
            isShiftOpen = false;
          } else {
            const match$8 = match$7._1;
            if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string" || match$8.TAG !== /* Kassa */ 2) {
              isShiftOpen = false;
            } else {
              const match$9 = match$8._0._0;
              if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string") {
                isShiftOpen = false;
              } else {
                const match$10 = match$9._1;
                if (/* tag */ typeof match$10 === "number" || typeof match$10 === "string" || match$10.TAG !== /* Journal */ 2) {
                  isShiftOpen = false;
                } else {
                  const match$11 = match$10._0;
                  if (/* tag */ typeof match$11 === "number" || typeof match$11 === "string") {
                    isShiftOpen = false;
                  } else {
                    let tmp$1 = match$11._0;
                    isShiftOpen = /* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* View */ 0 ? false : true;
                  }
                }
              }
            }
          }
        }
        break;
      default:
        isShiftOpen = false;
    }
  }
  const closeShiftButton = isShiftOpen ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
      route: contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: {
            TAG: /* Kkm */ 0,
            _0: id,
            _1: {
              TAG: /* Journal */ 2,
              _0: {
                TAG: /* Shifts */ 0,
                _0: /* List */ 0
              }
            }
          }
        }
      }),
      children: JsxRuntime.jsx("img", {
        className: "w-5 h-5",
        src: StaticAsset.src("/static/icons/close-20.svg")
      })
    }) : JsxRuntime.jsx("button", {
      children: JsxRuntime.jsx("img", {
        className: "w-5 h-5",
        src: StaticAsset.src("/static/icons/close-20.svg")
      }),
      onClick: (function (param) {
        Curry._1(setObjectId, (function (param) {
          
        }));
      })
    });
  let mobileHeader;
  if (objectId !== undefined) {
    switch (objectType) {
      case "kkm_receipt" :
        mobileHeader = JsxRuntime.jsx(Buhta_cabinet__ReceiptHeader.make, {
          id: id,
          receiptId: objectId,
          org: org,
          openMenu: openMenu,
          closeReceiptButton: closeReceiptButton
        });
        break;
      case "kkm_report" :
        mobileHeader = JsxRuntime.jsx(Buhta_cabinet__ShiftHeader.make, {
          kkm: id,
          id: objectId,
          closeShiftButton: closeShiftButton,
          openMenu: openMenu
        });
        break;
      default:
        mobileHeader = null;
    }
  } else {
    let exit = 0;
    if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
      exit = 1;
    } else {
      switch (currentRoute.TAG) {
        case /* Org */ 6 :
          const match$12 = currentRoute._1;
          if (/* tag */ typeof match$12 === "number" || typeof match$12 === "string" || match$12.TAG !== /* Kassa */ 2) {
            exit = 1;
          } else {
            const match$13 = match$12._0._0;
            if (/* tag */ typeof match$13 === "number" || typeof match$13 === "string") {
              exit = 1;
            } else {
              const match$14 = match$13._1;
              if (/* tag */ typeof match$14 === "number" || typeof match$14 === "string" || match$14.TAG !== /* Journal */ 2) {
                exit = 1;
              } else {
                const match$15 = match$14._0;
                if (/* tag */ typeof match$15 === "number" || typeof match$15 === "string") {
                  exit = 1;
                } else {
                  let tmp$2 = match$15._0;
                  exit = /* tag */ typeof tmp$2 === "number" || typeof tmp$2 === "string" || tmp$2.TAG !== /* View */ 0 ? 1 : 2;
                }
              }
            }
          }
          break;
        case /* Admin */ 7 :
          const match$16 = currentRoute._0;
          if (/* tag */ typeof match$16 === "number" || typeof match$16 === "string" || match$16.TAG !== /* Orgs */ 1) {
            exit = 1;
          } else {
            const match$17 = match$16._0;
            if (/* tag */ typeof match$17 === "number" || typeof match$17 === "string") {
              exit = 1;
            } else {
              const match$18 = match$17._1;
              if (/* tag */ typeof match$18 === "number" || typeof match$18 === "string" || match$18.TAG !== /* Kassa */ 2) {
                exit = 1;
              } else {
                const match$19 = match$18._0._0;
                if (/* tag */ typeof match$19 === "number" || typeof match$19 === "string") {
                  exit = 1;
                } else {
                  const match$20 = match$19._1;
                  if (/* tag */ typeof match$20 === "number" || typeof match$20 === "string" || match$20.TAG !== /* Journal */ 2) {
                    exit = 1;
                  } else {
                    const match$21 = match$20._0;
                    if (/* tag */ typeof match$21 === "number" || typeof match$21 === "string") {
                      exit = 1;
                    } else {
                      let tmp$3 = match$21._0;
                      exit = /* tag */ typeof tmp$3 === "number" || typeof tmp$3 === "string" || tmp$3.TAG !== /* View */ 0 ? 1 : 2;
                    }
                  }
                }
              }
            }
          }
          break;
        default:
          exit = 1;
      }
    }
    switch (exit) {
      case 1 :
        mobileHeader = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
          title: typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? "Касса" : kkmObj.VAL.name,
          leftChildren: backButton,
          openMenu: openMenu,
          subheader: subheader
        });
        break;
      case 2 :
        mobileHeader = JsxRuntime.jsx(Buhta_cabinet__ShiftHeader.make, {
          kkm: id,
          closeShiftButton: closeShiftButton,
          openMenu: openMenu
        });
        break;
    }
  }
  if (deviceType === "mobile") {
    return mobileHeader;
  } else {
    return JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Журнал"
    });
  }
}

const make = KkmJournalHeader;

export {
  make,
}
/* Buhta_cabinet__Kassa Not a pure module */
